import actionCreatorFactory from 'typescript-fsa';
import { AgencyUserInfo } from '../reducers/UserReducer';

const actionCreator = actionCreatorFactory();

export const agencyActions = {
  loginUser: {
    updateUser: actionCreator<AgencyUserInfo>('UPDATE_USER'),
  },
  updateLogInStatus: actionCreator<boolean>('UPDATE_LOG_IN_STATUS'),
  loginAgencyUser:{
    updateAgencyUser: actionCreator<AgencyUserInfo>('UPDATE_AGENCY_USER'),
  },
  signOut: actionCreator<void>('SIGN_OUT'),
};
